import { SOFT_HYPHEN_SYMBOL } from "../constants/softHyphen.constant";

export const softHyphenate = (string: string) =>
    string.replace(new RegExp(SOFT_HYPHEN_SYMBOL, "g"), "\u00AD");
